import { Field } from "react-final-form";
import { Input } from "component/inputs/Input";
import "../i18n";
import { useTranslation } from "react-i18next";
import { GeneralDataType } from "./types";
import { Button } from "@pickit/pickit-components";

const GeneralData = ({ testId, pickerId, countryCode }: GeneralDataType) => {
  const { t } = useTranslation();
  return (
    <div className="container-detail-preliquidation-row">
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-5">
        <Field
          type="text"
          name="fiscalData.fiscalNumber"
          label={t("invoice:fiscalNumber")}
          disabled={true}
          component={Input}
          className="Admin-Pickers-input"
          placeholder="-"
          testId={`${testId}-field-fiscal-number`}
        />
      </div>
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-5">
        <Field
          type="text"
          name="fiscalData.companyName"
          label={t("invoice:businessName")}
          component={Input}
          className="Admin-Pickers-input"
          placeholder="-"
          disabled={true}
          testId={`${testId}-field-company-name`}
        />
      </div>
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-5">
        <Field
          type="text"
          name="fiscalData.taxPayerType"
          label={t("invoice:typeOfTaxpayer")}
          component={Input}
          className="Admin-Pickers-input"
          placeholder="-"
          disabled={true}
          testId={`${testId}-field-tax-payer-type`}
        />
      </div>
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-5">
        <Field
          type="text"
          name="fiscalData.total"
          label={t("invoice:totalToPay")}
          component={Input}
          className="Admin-Pickers-input"
          placeholder="-"
          disabled={true}
          testId={`${testId}-field-total`}
        />
      </div>
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-5">
        <Field
          type="text"
          name="region"
          label={t("invoice:region")}
          component={Input}
          placeholder="-"
          className="Admin-Pickers-input"
          disabled={true}
          testId={`${testId}-field-region`}
        />
      </div>
      <div className="container-detail-preliquidation-col-sm-5 container-detail-preliquidation-col-lg-3">
        <div className="see-picker-container">
          <Button
            hierarchy="minimal-alt"
            label={t("invoice:seePicker")}
            onClick={() => window.open(`/${countryCode}/pickers/detail/${pickerId}?tab=pickers`)}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralData;
